const axios = require('axios')
const _baseUrl = '/gateway/business/api'

// 表态
export function expressAttitude (data) {
  const url = _baseUrl + '/expressAttitude'
  return axios.post(url, data).then((res) => {
    return Promise.resolve(res.data)
  })
}

// 获取赞成反对数据
export function getAttitudeList (data) {
  const url = _baseUrl + '/getAttitudeList'
  return axios.post(url, data).then((res) => {
    return Promise.resolve(res.data)
  })
}
